module.exports = __webpack_public_path__ + "static/media/product_houseview.d8eb0b01.png";